import { AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, Input, Output, ViewChild } from '@angular/core';
import { FormsModule, NgModel } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatCalendarCellClassFunction, MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatLabel, MatSuffix } from '@angular/material/input';
import { AutocompleteOffDirective } from 'directives/autocomplete-off.directive';
import { InputStateDirective } from 'directives/input-state.directive';
import { ValidationDirective } from 'directives/validation.directive';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { DateService } from 'services/date.service';

@Component({
	selector: 'date-input',
	templateUrl: 'date-input.component.html',
	imports: [MatFormField, MatLabel, InputStateDirective, MatInput, MatDatepickerInput, FormsModule, ValidationDirective, AutocompleteOffDirective, MatIconButton, MatSuffix, MatIcon, MatDatepickerToggle, MatDatepicker]
})
export class DateInputComponent implements AfterViewInit {
	constructor(private readonly element: ElementRef<HTMLElement>, private readonly customDate: CustomDatePipe, private readonly dateService: DateService) {}

	@ViewChild(NgModel) ngModel?: NgModel;

	@Input() label = '';
	@Input() placeholder = '';
	@Input() required = false;
	@Input() disabled = false;
	@HostBinding('class.disabled') getDisabled() { return this.disabled; }

	@Input()
	set value(value: Date | undefined) {
		this._value = value;
		this.formatValue();
	}
	get value() {
		return this._value;
	}

	@Input() minDate?: Date | undefined;
	@Input() maxDate?: Date | undefined;
	@Input() filterDates?: Date[];

	filteredDates = (d: Date | null): boolean => {
		if (!this.filterDates) return true;

		const calendarDay = d || new Date();
		return this.filterDates.some(date => this.dateService.getDiffInDays(date, calendarDay) == 0);
	 };

	@Output() valueChange = new EventEmitter();
	@Output() blur = new EventEmitter();

	public displayDatePicker = false;
	private _value?: Date;

	public displayValue = '';

	private valid = false;
	public validationMessage = '';

	dateClass: MatCalendarCellClassFunction<Date> = (date, view) => {
		const day = date.getDay();
		if (view === 'month' && day === 6 || day === 0) return 'weekend-date';
		return '';
	};

	private formatValue() {
		this.displayValue = this.value ? this.customDate.transform(this.value, 'shortDate') : '';
	}
	public clicked(target: any) {
		if (!this.element.nativeElement.contains(target)) this.setFocus(false);
	}
	public setFocus(hasFocus: boolean) {
		this.displayDatePicker = hasFocus;
		this.validationMessage = '';
		if (!hasFocus) {
			this.blur.emit(true);
			if (!this.valid) this.validationMessage = 'required';
		}
	}
	ngAfterViewInit(): void {
		if (this.ngModel?.invalid)
			setTimeout(() => {
				if (this.ngModel?.value != undefined)
					this.ngModel.control.markAsTouched();
			});
	}

	valueChanged() {
		if (this.ngModel) this.ngModel.control.markAsDirty();
		this.valueChange.emit(this.value ? this.dateService.getDate(this.value) : undefined);
		this.setFocus(false);
	}

	resetInput() {
		if (this.ngModel) this.ngModel.control.markAsDirty();
		this.value = undefined;
		this.valueChanged();
	}
}
